export default "__VITE_ASSET__992ea64e__"